import axiosInstance from '@/utils/api.js'

var state = {
  replacementsInDocument: []
}

var getters = {
  REPLACEMENTS_IN_DOCUMENT: (state) => {
    return state.replacementsInDocument
  }
}

var mutations = {
  SET_REPLACEMENTS_IN_DOCUMENT: (state, payload) => {
    state.replacementsInDocument = payload
  }
}

var actions = {
  GET_REPLACEMENTS_IN_DOCUMENT: async (context, payload) => {
    let result = await axiosInstance.get('/settings/documents/replacements')
    if (result.status === 200) {
      context.commit('SET_REPLACEMENTS_IN_DOCUMENT', result.data)
    }
  },
  CREATE_REPLACEMENTS_IN_DOCUMENT: (context, payload) => {
    return axiosInstance.post('/settings/documents/replacements', payload)
  },
  DELETE_REPLACEMENTS_IN_DOCUMENT: (context, payload) => {
    return axiosInstance.delete('/settings/documents/replacements?key=' + payload)
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/stores/settings/replacementsInDocument.js